import React from 'react';
import { ArrowUpRightIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { NewTabHint } from '../ui/NewTabHint';
import type { BcmEvent } from '../../data/events';
const dotStyles: Record<BcmEvent['category'], string> = {
  'Fall 2026': 'bg-brand-yellow',
  Weekly: 'bg-brand-blue',
  'Coming Soon': 'bg-brand-pink'
};

/**
 * Compact calendar-style list view. Reads the same event data as the card view.
 */
export function EventList({
  events
}: {
  events: BcmEvent[];
}) {
  return <ul className="overflow-hidden rounded-[24px] border-2 border-brand-navy bg-white" data-id="element-90" data-mp="dy0eabkkt8dp">
      {events.map((event, index) => <li key={event.id} className={`flex flex-col gap-3 p-5 sm:flex-row sm:items-start sm:gap-6 sm:p-6 ${index > 0 ? 'border-t-2 border-brand-navy/15' : ''}`} data-id="element-91" data-mp="ro3uaksv45up" data-mpi={index}>
          <div className="sm:w-56 sm:shrink-0" data-id="element-92" data-mp="11nukiaae3yoz">
            <p className="flex items-center gap-2 font-meta text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy" data-id="element-93" data-mp="woi1y1qjxds7">
              <span aria-hidden="true" className={`h-2.5 w-2.5 rounded-full ${dotStyles[event.category]}`} data-id="element-94" data-mp="2v538ovh6vu8t" />
              {event.category}
            </p>
            <p className="mt-1.5 font-display text-base font-bold leading-snug text-brand-navy" data-id="element-95" data-mp="344g8ewfih4gc">
              {event.date}
            </p>
            {event.time ? <p className="mt-1 flex items-center gap-1.5 font-meta text-[13px] text-ink" data-id="element-96" data-mp="394uisl4l4qhj">
                <ClockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-97" data-mp="3e2dubd9wep5s" />
                {event.time}
              </p> : null}
          </div>

          <div className="min-w-0" data-id="element-98" data-mp="3nrxgoswtl15e">
            <h3 className="font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-99" data-mp="3nsz13nzq6zzs">
              {event.title}
            </h3>
            <p className="mt-1.5 font-sans text-[15px] leading-relaxed text-ink" data-id="element-100" data-mp="3rvvhr95pgm13">
              {event.description}
            </p>
            {event.locationDetail || event.location || event.locationNote ? <p className="mt-2 flex items-start gap-1.5 font-meta text-[13px] text-ink" data-id="element-101" data-mp="21ppfr80azcd0">
                <MapPinIcon aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-navy" data-id="element-102" data-mp="1wqw3fiwr5ref" />
                {event.locationDetail ?? event.location ?? event.locationNote}
              </p> : null}
            {event.clarification ? <p className="mt-1.5 font-meta text-[12.5px] text-ink" data-id="element-103" data-mp="2kg6x6gfoqlj2">{event.clarification}</p> : null}
            <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2" data-id="element-104" data-mp="2gfmy37bjx7ua">
              {event.cta ? <a href={event.cta.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-meta text-[13px] font-semibold text-brand-navy underline underline-offset-4 hover:no-underline" data-id="element-105" data-mp="2uewd43o0tvwo">
                  {event.cta.label}
                  <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-106" data-mp="v3myfouspgyi" />
                  <NewTabHint data-id="element-107" data-mp="36pducoi7l7ws" />
                </a> : null}
              {event.reference ? <a href={event.reference.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-meta text-[13px] font-semibold text-brand-navy underline underline-offset-4 hover:no-underline" data-id="element-108" data-mp="3bn75lvydcs3x">
                  {event.reference.label}
                  <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-109" data-mp="2syiir4gbscpi" />
                  <NewTabHint data-id="element-110" data-mp="2e0q4sgqffwdf" />
                </a> : null}
            </div>
          </div>
        </li>)}
    </ul>;
}